import { useTranslation } from "react-i18next";

import { IconUserDown02 } from "@pentabd/icons";
import { Button, Header } from "@pentabd/ui";
import { STATUS } from "@constants/status.hrm";
import { FileInquiryHistoryResponse } from "@type/HRM/fileInquiry";
import { useUser } from "@hooks/useUser";
import { getAccess } from "@helpers/permissionController";
import { useState } from "react";
import { fileInquiryAssign, fileInquiryFlow } from "@api/fileInquiry";
import { FormProvider, useForm } from "react-hook-form";
import { ErrorModal, SuccessModal } from "@components";
import { FileInquiryModal } from "./FileInquiryModal";
import { useFunctionalityData } from "@hooks/useFunctionalityData";
import { FUNCTIONALITY_DATA } from "@constants/functionality-data";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@constants/routes";

const { PENDING_FOR_REVIEW, UNASSIGNED } = STATUS;

const { APPROVAL_MATRIX } = FUNCTIONALITY_DATA;

const {
  HRM: { FILE_INQUIRY },
} = ROUTES;
export const ReleaseListPageHeader = ({
  id,
  fileInquiryHistory,
}: // refetchFileInquiry,
{
  id: string | undefined;
  fileInquiryHistory: FileInquiryHistoryResponse | undefined;
  // refetchFileInquiry?: (fileId: string | undefined) => Promise<void>;
}) => {
  const { t } = useTranslation();
  const {
    user: { employeeMasterId, realm_roles: roles },
  } = useUser();
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const methods = useForm();
  const navigate = useNavigate();
  const { data: designation } = useFunctionalityData(APPROVAL_MATRIX);

  const breadcrumbs = [
    {
      icon: <IconUserDown02 size="20" />,
    },
    {
      label: t("FILE_INQUIRY.BREADCRUMBS.FIRST_STEP"),
    },
  ];

  const headerText = {
    header: t("FILE_INQUIRY.HEADING"),
    subHeader: t("FILE_INQUIRY.DESCRIPTION"),
  };

  const handleApprove = () => {
    if (id) {
      setIsLoading(true);
      fileInquiryFlow(
        id,
        {
          status: "APPROVED",
        },
        (response) => {
          if (response.status === "success") {
            setIsSuccessModalOpen(true);
          } else {
            setIsErrorModalOpen(true);
          }
          setIsLoading(false);
        },
      );
    }
  };

  const actions = [
    fileInquiryHistory?.status === PENDING_FOR_REVIEW &&
    fileInquiryHistory?.handOverId?.toString() ===
      employeeMasterId?.toString() ? (
      <Button
        type="primary"
        fill="fill"
        size="sm"
        onClick={handleApprove}
        loading={isLoading}
      >
        {t("FILE_INQUIRY.APPROVE_BUTTON")}
      </Button>
    ) : (
      <></>
    ),
    getAccess(roles, "CAN_ASSIGN_FILE_INQUIRY") &&
    fileInquiryHistory?.status === UNASSIGNED ? (
      <Button
        type="primary"
        fill="fill"
        size="sm"
        onClick={() => {
          setIsModalOpen(true);
          methods.reset({
            assigneeId: employeeMasterId,
            fileFromDate: "",
          });
        }}
      >
        {t("FILE_INQUIRY.ASSIGN_BUTTON")}
      </Button>
    ) : (
      <></>
    ),
  ];

  return (
    <FormProvider {...methods}>
      <SuccessModal
        isModalOpen={isSuccessModalOpen}
        action={() => {
          setIsSuccessModalOpen(false);
          navigate(`${FILE_INQUIRY}`);
        }}
      />
      <ErrorModal
        isModalOpen={isErrorModalOpen}
        closeModal={() => setIsErrorModalOpen(false)}
      />
      <Header
        breadcrumbs={breadcrumbs}
        headerText={headerText}
        actions={actions}
      />
      <FileInquiryModal
        isModalOpen={isModalOpen}
        designation={designation}
        onClose={() => setIsModalOpen(false)}
        gradeId={10}
        isLoading={isLoading}
        handleSendForApproval={(data: {
          assigneeId: number;
          fileFromDate: string;
        }) => {
          setIsLoading(true);
          fileInquiryAssign(
            {
              ...data,
              enquiryFileId: Number(id),
              assignerId: Number(employeeMasterId),
            },
            (response) => {
              if (response.status === "success") {
                setIsModalOpen(false);
                setIsSuccessModalOpen(true);
                setIsModalOpen(false);
                // if (refetchFileInquiry) {
                //   refetchFileInquiry(id);
                // }
                // navigate(`${FILE_INQUIRY}`);
              } else {
                setIsErrorModalOpen(true);
              }
              setIsLoading(false);
            },
          );
        }}
      />
    </FormProvider>
  );
};
